<template>
  <div class="pm200">
    <!-- <img src="../../assets/img/banner.jpg" class="banner w100 cz" /> -->
    <div>
      <div class="kjnjsfoer pd pt20">
        <div style="display: flex; justify-content: space-between;">
          <p class="fz16 z3">参观日期</p>
          <p class="fz16" style="color:red;">周一闭馆（法定节假日除外）</p>
        </div>
        <div class="row">
          <div
            class="kjmmjknmxer cen mr15"
            v-for="(date, idx) in options.dates"
            :key="date.date"
            :class="{
              act: orderInput.travelDate === date.date,
              disabled: date.disable,
            }"
            @click="dateChanged(idx)"
          >
            <p class="fz12 z9 dfgdt">{{ date.text.substr(0, 2) }}</p>
            <div class="cen btm z9 fz14">
              {{ date.disable ? "不可订" : date.text.substr(2) }}
            </div>
          </div>
          <div class="col">
            <div class="kjmmjknmxer cen mr15 w100" @click="selectMoreDate">
              <p class="fz12 z9 dfgdt">更多</p>
              <div class="cen btm zts fz16">
                <i class="f_i gengdder"></i>
              </div>
            </div>
          </div>
        </div>
        <p class="mt15 fz16">
          请选择票类
        </p>
        <van-grid
          v-if="grounds[0]"
          :border="false"
          :column-num="1"
          style="margin-right: -10px"
        >
          <van-grid-item
            v-for="ground in grounds[0].children"
            :key="ground.value"
            :name="ground.value"
          >
            <div
              class="row fgdrtwer"
              :class="[
                ground.disabled || wxLastBookTime ? 'acb' : '',
                orderInput.groundId == ground.value ? 'act' : '',
              ]"
              @click="groundChange(ground)"
            >
              <div class="col pl15 pr15 z8 fz14 kmmxeert2">
                {{ ground.displayText }}
              </div>
              <div class="kmmxeert">
                <i class="f_i gounmxer" v-if="!ground.disabled"></i>
                <div v-else class="kjnmkxerse">闭<br />馆</div>
              </div>
            </div>
          </van-grid-item>
        </van-grid>
        <van-row>
          <div v-if="wxLastBookTime" class="panel-content">
            <div class="content-text2">
              超过今天最晚预约时间 {{ wxLastBookTime }}
            </div>
          </div>
        </van-row>
      </div>
      <div class="pd mt10">
        <p class="mt10 fz16">
          参观时段
          <span class="z9 fz12"> (在该时段入场参观)</span>
        </p>
        <van-grid
          v-if="!wxLastBookTime && orderInput.groundId && changCis[0]"
          :border="false"
          :column-num="2"
          style="margin-right: -10px"
        >
          <van-grid-item
            v-for="changCi in changCis[0].children"
            :key="changCi.value"
            :name="changCi.value"
          >
            <div
              class="fgdrtwerab"
              :class="[orderInput.changCiId == changCi.value ? 'act' : '']"
              @click="changCiChange(changCi)"
            >
              <p class="fz17 z6">{{ changCi.text }}</p>
              <p class="zts fz12">{{ "(余票:" + changCi.surplusNum + ")" }}</p>
            </div>
          </van-grid-item>
        </van-grid>
        <div
          v-if="!wxLastBookTime && !orderInput.groundId"
          class="panel-content"
        >
          <div class="content-text2">请先选择参观区域</div>
        </div>
      </div>
      
      <div class="mt10" style="height: 45px">
          <van-field
          label="团队名称"
          :maxlength="50"
          placeholder="必填，请输入团队名称"
          v-model="orderInput.customerName"
          clearable
        ></van-field>
          <!-- <div
            class="cz"
            style="
              color: #646566;
              float: left;
              padding-left: 16px;
              padding-right: 12px;
              margin-top: 11px;
              font-size: 14px;
            "
          >
            团队名称
          </div>
          <el-autocomplete
            @focus="onQuerySearchFocus"
            class="inline-input querySearch"
            v-model="state1"
            :maxlength="50"
            :fetch-suggestions="querySearch"
            placeholder="必填，请输入团队名称"
            @select="handleSelect"
          ></el-autocomplete> -->
        </div>

      <!-- <van-cell-group class>
        <div class="pd pt10 row pm10">
          <p style="padding-right: 30px; font-size: 14px; color: #646566">
            客源类型
          </p>
          <van-radio-group
            class="col"
            v-model="keYuanTypeId"
            direction="horizontal"
          >
            <van-radio checked-color="#810102" name="1">内宾</van-radio>
            <van-radio checked-color="#810102" name="2">外宾</van-radio>
            <van-radio checked-color="#810102" name="4">港澳台</van-radio>
          </van-radio-group>
        </div>
      </van-cell-group> -->
      <div
        class="pd pt10 pm10"
        v-if="keYuanTypeId == 1 || keYuanTypeId == 2 || keYuanTypeId == 4"
      >
        <div class="pd sdfsdtywer pm10">
          <div class="pt10 pm10 row fz14">
            年龄段
            <span class="zts fz12">{{
              "*每单最多" + groupOrderMaxQuantity + "人"
            }}</span>
            <p class="col tr z3">参观人数</p>
          </div>
          <div class="btm pt10">
            <div
              class="row pt5 pm5"
              v-for="(ageRange, index) in ageRanges"
              :key="index"
            >
              <p class="col fz12 z3">{{ ageRange.displayText }}</p>
              <van-stepper
                v-model="ageRange.personNum"
                :min="0"
                :max="groupOrderMaxQuantity"
                integer
              />
            </div>
          </div>
        </div>
      </div>
      <div class="pd pt10 pm10" v-else>
        <div class="row mb10">
          <p
            class="col"
            style="padding-left: 6px; font-size: 14px; color: #646566"
          >
            参观人数
          </p>
          <van-stepper
            async-change
            :value="adultQuantity"
            :defaultValue="0"
            :min="0"
            :max="groupOrderMaxQuantity"
            @change="onAdultQuantity"
            integer
          />
        </div>
        <div class="tourist-tips">
          <van-icon name="info-o" />
          <span>
            {{ "*每单最多" + groupOrderMaxQuantity + "人" }}
          </span>
        </div>
        <div class="sdfsdtywer">
          <div v-for="(adult, index) in orderInput.adults" :key="index">
            <van-cell-group>
              <div class="jjnnjxer ml10 fz14 adult-index">
                {{ index + 1 }}
              </div>
              <div>
                <van-field
                  label="姓名"
                  ref="adultName"
                  class="adultName ml20"
                  maxlength="30"
                  placeholder="必填，输入证件上的姓名"
                  v-model="adult.name.value"
                  :error="adult.name.error"
                  clearable
                >
                </van-field>
                <van-field
                  clickable
                  label="证件号码"
                  ref="certNo"
                  class="certNo ml20"
                  maxlength="18"
                  placeholder="必填，请输入身份证号码"
                  v-model="adult.certNo.value"
                  :error="adult.certNo.error"
                  clearable
                  @focus="onCertNoFocus(index)"
                  @touchstart.native.stop="onShowNumberKeyboard(index)"
                />
              </div>
            </van-cell-group>
          </div>
        </div>
      </div>
      <!-- <van-cell-group class>
        <van-field
          label="带队人员"
          :maxlength="30"
          placeholder="输入带队人员姓名"
          v-model="orderInput.jidiaoName"
          clearable
        ></van-field>
        <date-field
          label="参观时间"
          placeholder="选择时间"
          v-model="orderInput.arrivalTime"
          type="time"
          :min-hour="minHour"
          :max-hour="maxHour"
        />
      </van-cell-group> -->

      <div class="pd bgff">
        <p v-if="explainers.length>0" class="mt15 fz16 pm10">
          讲解场次
          <!-- <span class="z9 fz12"> (疫情期间暂不提供讲解)</span> -->
        </p>
        <van-cell-group v-if="explainers.length>0">
          <van-cell title="需要讲解" class="field-cell left">
            <div class="explain">
              <van-switch
                v-model="orderInput.needExplain"
                size="18px"
                class="group-order-switch"
                active-color="#845F56"
              />
              <div
                class="explain-tips"
                v-if="options.groupExplainAdvanceDays > 0"
              >
                <van-icon name="info-o" />
                <span>须提前{{ options.groupExplainAdvanceDays }}天预约</span>
              </div>
            </div>
          </van-cell>
        </van-cell-group>
        <div v-if="orderInput.needExplain">
          <div v-for="(explainer, idx) in explainers" :key="idx">
            <div v-if="explainer.children.length > 0">
              <p class="fz12 z9 pt10">请选择{{ explainer.text }}讲解时段</p>
              <van-row gutter="28">
                <van-col
                  span="12"
                  v-for="child in explainer.children"
                  :key="child.value"
                  @click="onSelectExplainerTimePoint(child, explainer.children)"
                >
                  <div
                    class="fgdrtwerab"
                    :class="[child.selected ? 'act' : '']"
                  >
                    <p class="fz17 z6">{{ child.text.substr(0, 11) }}</p>
                    <p class="zts fz12">{{ child.text.substr(11) }}</p>
                  </div>
                </van-col>
              </van-row>
            </div>
          </div>

          <div class="row pt15 dfghyuwrr">
            <span class="fz14">备注</span>
            <div class="pl col pl10">
              <input
                type="text"
                placeholder="请输入内容"
                class="sfgdywer"
                v-model="orderInput.memo"
              />
            </div>
          </div>
        </div>
        <div v-if="packingLotId">
          <p class="mt20 fz16 pm10">停车位信息</p>
          <van-cell-group class>
            <van-cell title="需要停车位" class="field-cell left">
              <div class="explain">
                <van-switch
                  v-model="orderInput.needPackingLot"
                  size="18px"
                  class="group-order-switch"
                  active-color="#845F56"
                />
              </div>
            </van-cell>
          </van-cell-group>

          <div v-if="orderInput.needPackingLot && packingLotId">
            <div class="row">
              <p
                class="col mt10 mb10"
                style="padding-left: 16px; font-size: 14px; color: #646566"
              >
                车位数量
              </p>
              <van-stepper
                class="row mt5"
                async-change
                :value="licensePlateNumberQuantity"
                :defaultValue="1"
                :min="0"
                :max="maximumParkingSpacesForTeamBooking"
                @change="onLicensePlateNumberQuantity"
                integer
                disable-input
              />
            </div>
            <div class="tourist-tips">
              <van-icon name="info-o" />
              <span>
                小型车:余{{ carSpacingNum }}车位， 大客车:余{{
                  busSpacingNum
                }}车位
              </span>
            </div>
            <div class="sdfsdtywer">
              <van-cell-group
                v-for="(licensePlateNumber, index) in licensePlateNumbers"
                :key="index"
              >
                <div class="jjnnjxer ml10 fz14 adult-index">
                  {{ index + 1 }}
                </div>
                <div>
                  <van-cell
                    class="pl30"
                    title="车辆类型"
                    :value="licensePlateNumber.carTypeName || '请选择'"
                    :value-class="licensePlateNumber.carTypeId ? 'z3' : ''"
                    is-link
                    @click="onShowCarType(index)"
                  />
                  <van-field
                    readonly
                    class="pl30"
                    maxlength="8"
                    placeholder="必填，请输入车牌号码"
                    :value="licensePlateNumber.licensePlateNumber"
                    @focus="cphClick(index)"
                  >
                    <template slot="label">
                      <span class="cz">车牌号码</span>
                    </template>
                  </van-field>
                </div>
              </van-cell-group>
            </div>
          </div>
        </div>
        <p class="mt15 fz16 pm10">联系人信息</p>
        <van-cell-group>
          <van-field
            label-class=""
            label="姓名"
            :maxlength="30"
            placeholder="必填，请输入联系人姓名"
            v-model="orderInput.contactName"
            clearable
          ></van-field>
          <van-field
            label="手机号码"
            :maxlength="11"
            placeholder="必填，请输入联系人手机号码"
            type="tel"
            v-model="orderInput.contactMobile"
            clearable
          ></van-field>
          <van-field
            clickable
            label="身份证号"
            class="contactCertNo"
            maxlength="18"
            placeholder="必填，请输入联系人身份证号"
            v-model="contactCertNo.value"
            :error="contactCertNo.error"
            clearable
            @focus="onContactCertNoFocus()"
            @touchstart.native.stop="onShowContactNumberKeyboard()"
          />
        </van-cell-group>
        <p class="mt15 fz16 pm10">预约凭证</p>
        <van-cell-group>
          <van-field label="注意事项" type="textarea" autosize value="团队至少提前两天预约,等待审核通过方能前住参观" class="van-field-red" readonly style="color:red;" />
          <van-field label-width="85px !important" label="凭证上传提示" type="textarea" autosize value="团队预约表填好后导出PDF格式且必须上传，请按照模版样式提供预约函和参观人员名单，工作人员将在24小时内完成资格审核。" class="van-field-notice" readonly />
          <van-cell title-style="min-width:85px" center class="uploader">
              <template slot="title">
                 <div class="cz">
                  预约凭证上传<br>
                 </div>
                 <div style="line-height:14px;">
                 <p style="font-size:10px;">( pdf 最大 500kb )</p>
                 <p style="font-size:10px;">( jpeg 最大 20mb )</p>
                 </div>
              </template>
              <van-uploader v-model="orderInput.fileList" multiple :max-count="1" preview-size="80px" upload-icon="plus" upload-text="选择文件"  style="text-align: center; line-height: 14px;" accept="application/pdf,image/jpeg" :before-delete="beforeDelete" :before-read="beforeRead" :after-read="afterRead" />
              <a href="../凭证模版.docx" target="_blank">凭证模版下载</a>
            </van-cell>
        </van-cell-group>
        <!-- <van-button type="primary" block class="mt20" @click="onTempSave"
          >临时保存（有效期1天）</van-button
        > -->
        <div class="pd pt10 pm10 fz14 checkbox">
          <van-checkbox
            shape="square"
            :value="checked"
            @click="onValidate"
            icon-size="16px"
            checked-color="#845F56"
          >
            <!-- 请认真填写上述信息，填写内容需真实有效，如果填写信息有误，您个人需承担相应法律责任，请配合现场工作人员各项措施和要求。 -->
            请认真填写上述信息，内容需真实有效，如果填写信息有误，您需承担相应法律责任，<span style="color:red;">敬请关注“叶挺纪念馆票务预约”服务号，将通过服务号向您推送团队预约审核通知信息。</span>
          </van-checkbox>
          <bottom-button
            text="立即预约"
            :loading="loading"
            @click="onSubmit"
            :class="!checked ? 'sdrtter' : ''"
          ></bottom-button>
        </div>
      </div>
    </div>
    <div v-for="(adult, index) in orderInput.adults" :key="index">
      <van-number-keyboard
        safe-area-inset-bottom
        theme="custom"
        class=""
        :title="
          adult.certNo.value
            ? '身份证：' + adult.certNo.value
            : '请输入' +
              (adult.name.value ? adult.name.value + '的' : '') +
              '身份证号码'
        "
        v-model="adult.certNo.value"
        :show="showNumberKeyboards[index].show"
        :maxlength="18"
        extra-key="X"
        close-button-text="完成"
        @blur="onBlurNumberKeyboard(index)"
      />
    </div>
    <van-number-keyboard
      safe-area-inset-bottom
      theme="custom"
      class=""
      :title="
        contactCertNo.value
          ? '身份证：' + contactCertNo.value
          : '请输入' +
            (orderInput.contactName ? orderInput.contactName + '的' : '') +
            '身份证号码'
      "
      v-model="contactCertNo.value"
      :show="showContactNumberKeyboards"
      :maxlength="18"
      extra-key="X"
      close-button-text="完成"
      @blur="onBlurContactNumberKeyboard()"
    />
    <van-calendar
      v-model="showDateTimePicker"
      @confirm="confirmMoreDate"
      color="#810102"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <van-action-sheet
      v-model="showCarType"
      :actions="carTypes"
      @select="onCarTypeSelecter"
    />
    <car-key-board
      v-model="showkeyboard"
      :plateNumber="cph"
      :idx="clickIndex"
      @confirmBtnFn="confirmBtnFn"
    />
  </div>
</template>

<script>
import DateSelector from "@/components/DateSelector.vue";
import DateField from "@/components/DateField.vue";
import BottomButton from "@/components/BottomButton.vue";
import PickerField from "@/components/PickerField.vue";
import CarKeyBoard from "@/components/CarKeyBoard.vue";
import moment from "moment";
import validate from "@/utils/validator.js";
import dateHelper from "@/utils/dateHelper.js";
import orderService from "@/services/orderService.js";
import { mapState } from "vuex";
// import store from "@/store/consts.js";
import explainerService from "@/services/explainerService.js";
import commonService from "@/services/commonService.js";
import scenicService from "../../services/scenicService.js";
// import customerService from "@/services/customerService.js";
import IdcardField from "@/components/IdCardField.vue";
import Cookies from "js-cookie";
import Vue from "vue";
import fileHelper from "@/utils/fileHelper.js";
import imageHelper from "@/utils/imageHelper.js";

let defaultMinHour = 8;
let defaultArrivalTime = "";

function Tourist() {
  this.type = "团体";
  this.name = {
    value: "",
    error: false,
    errorMessage: "",
  };
  this.certTypeId = 5;
  this.certTypeName = "二代身份证";
  this.certNo = {
    value: "",
    error: false,
    errorMessage: "",
    placeholder: "请输入证件号码",
    label: "证件号码",
  };
  this.birthday = "";
}
function LicensePlateNumber() {
  this.licensePlateNumber = "";
  this.carTypeId = ""; //大客车
  this.carTypeName = "";
}

export default {
  components: {
    DateSelector,
    DateField,
    BottomButton,
    PickerField,
    CarKeyBoard,
    IdcardField,
  },
  props: {
    ticketTypeIds: {
      type: String,
    },
  },
  data() {
    return {
      cph: new Array(8),
      showkeyboard: false,
      clickIndex: 0,
      cookieOrderInput: {},
      hasCookieOrderInput: false,
      loading: false,
      loadingExplainer: false,
      minHour: defaultMinHour,
      maxHour: 18,
      orderInput: {
        travelDate: "",
        personNum: 1,
        arrivalTime: defaultArrivalTime,
        needPackingLot: false,
        plateNumbers: [],
        carTypeId: "",
        needExplain: false,
        explainerTimeslotSchedulings: [],
        contactName: "",
        contactMobile: "",
        certTypeId: "",
        certTypeName: "",
        contactCertNo: "",
        keYuanTypeId: "",
        areaId: "",
        jidiaoName: "",
        memo: "",
        groundId: "",
        changCiId: "",
        adultQuantity: 0,
        adults: [],
        childrenQuantity: 0,
        children: [],
        fileList: [],
      },
      licensePlateNumberQuantity: 1,
      licensePlateNumbers: [{ licensePlateNumber: "", carTypeId: "" }],
      keYuanTypeId: "1",
      ageRanges: [],
      explainers: [],
      keYuanTypes: [],
      areaItems: [],
      regions: [],
      regionId: "",
      areas: [],
      options: {
        dates: [],
        maxBookDays: 30,
      },
      grounds: [],
      changCis: [],
      wxLastBookTime: "",
      showDateTimePicker: false,
      carSpacingNum: 0,
      busSpacingNum: 0,

      carTypes: [],
      showCarType: false,
      showCarTypeIndex: 0,
      carTypeName: "",
      checked: false,
      packingLotId: "",

      adultQuantity: 0,
      showNumberKeyboards: [],

      showContactNumberKeyboards: false,
      contactCertNo: {
        value: "",
        error: false,
        errorMessage: "",
        placeholder: "请输入证件号码",
        label: "证件号码",
      },
      fileList: [],

      restaurants:[],
      state1: "",
    };
  },
  computed: {
    addTicketTypeIds() {
      return this.ticketTypeIds;
    },
    groupOrderMaxQuantity() {
      if (
        this.options.groupOrderMaxQuantity > 0 &&
        this.options.groupOrderMaxQuantity < 300
      ) {
        return this.options.groupOrderMaxQuantity;
      }
      return 300;
    },
    maximumParkingSpacesForTeamBooking() {
      var spacingNum = this.busSpacingNum + this.carSpacingNum;
      var maximum = 10;
      if (
        this.options.maximumParkingSpacesForTeamBooking > 0 &&
        this.options.maximumParkingSpacesForTeamBooking <= 10
      ) {
        maximum = this.options.maximumParkingSpacesForTeamBooking;
      }
      return maximum > spacingNum ? spacingNum : maximum;
    },
    showArea() {
      return this.areas.length > 0 && this.areas[0].children.length > 0;
    },
    minDate() {
      let date = this.options.dates.filter((d) => !d.disable)[0];
      if (date) {
        return new Date(date.date);
      }
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },
    maxDate() {
      const date = moment().add(this.options.maxBookDays, "days").toDate();
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    ...mapState({
      member: (state) => state.memberModule.member,
    }),
  },
  methods: {
    isOverSize(file){
      const maxSizeaa = (Number)(file.type === 'image/jpeg' ? (20 * 1024 * 1024) : (500 * 1024));
      return file.size >= maxSizeaa;
    },
    onOversize(){
        this.$toast('上传 jpeg 文件大小不能超过 20mb，pdf 文件大小不能超过 500kb');
    },
    preview() {
      // if (this.group.photo) {
      //   this.showImagePreview = true;
      // }
    },
    beforeRead(input){
      var file=input;
      if(Array.isArray(input)){
        file=input[0];
      }

      if (file.type == 'application/pdf')
      {
        if(file.size>500 * 1024){
          this.$toast('pdf 文件大小不能超过 500kb');
          return false;
        } 
      }else if (file.type == 'image/jpeg' ) 
      {
        if(file.size>20 * 1024 * 1024){
          this.$toast('jpeg 文件大小不能超过 20mb');
          return false;
        } 
      }
      // else if (file.type == 'image/png' )
      // {
        
      // }
      else{
        this.$toast('请上传 .pdf 或 .jpeg 文件');
        return false;
      }

      return true;
    },
    async beforeDelete(file){
      await orderService.delOrderAttachsAsync(file)
      //return false;
    },
    async afterRead(input) {
      try {
        var file=input;
        if(Array.isArray(input)){
          file=input[0];
        }
        //此时可以自行将文件上传至服务器
        file.status = 'uploading';
        file.message = '上传中...';
        const formData = new FormData();
        formData.append("status", file.status);
        formData.append("message", file.message);
        var dataUrl = file.content;
        if(file.file.type=="image/jpeg"){
          //压缩
          var img = await imageHelper.resize(dataUrl,600,840);
          dataUrl = img.photo;
        }

        var blob = fileHelper.dataURLToBlob(dataUrl)
        formData.append("content", blob);
        commonService.uploadFileAsync(formData, file.file.type).then(filePath=>{
          file.status = 'success';
          file.message = '上传成功';
          file.fileType = file.file.type.split("/")[1];
          file.fileName = file.file.name.split(".")[0].substring(0,49-file.file.name.split(".")[1].length)+"."+file.file.name.split(".")[1]
          file.filePath = filePath;
          file.content = dataUrl;
        }).catch(()=>{
          file.status = 'failed';
          file.message = '上传失败';
        });
        setTimeout(() => {
          if(file.status != 'success'){
            file.status = 'failed';
            file.message = '上传失败';
          }
        }, 5000);
      } catch (error) {
        this.orderInput.fileList=[];
      }
    },
    handleSelect(item) {
      this.orderInput.customerId = item.id;
      this.orderInput.customerName = item.value;
      // this.regionId = "";
      // this.regions[0].children.forEach((region) => {
      //   if (this.regionId == "") {
      //     region.children.forEach((child) => {
      //       if (this.regionId == "" && child.value == item.registAreaId) {
      //         if (region.value == "") {
      //           this.areas = [
      //             {
      //               text: "",
      //               children: [],
      //             },
      //           ];
      //         } else {
      //           this.regionId = region.value;
      //         }
      //       }
      //     });
      //   }
      // });
      // this.orderInput.areaId = item.registAreaId;
    },
    onQuerySearchFocus() {
      let top = 0;
      let element = document.querySelectorAll(".querySearch")[0];
      while (element) {
        top += element.offsetTop;
        element = element.offsetParent;
      }
      window.scrollTo(0, top - 50);
    },

    querySearch(queryString, cb) {
      if (this.orderInput.customerName != queryString.trim()) {
        this.orderInput.customerName = queryString.trim();
        this.orderInput.customerId = "";
        this.regionId = "";
        this.orderInput.areaId = "";
      }

      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : []; //restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
        );
      };
    },
    confirmBtnFn(e) {
      this.licensePlateNumbers[e.idx].licensePlateNumber = e.plateNumber;
    },
    cphClick(i) {
      this.clickIndex = i;
      var tempcph = [];
      var PlateNumber =
        this.licensePlateNumbers[i].licensePlateNumber.split("");
      for (var j = 0; j < PlateNumber.length; j++) {
        if (j < 8) {
          tempcph.push(PlateNumber[j]);
        }
      }

      this.cph = tempcph;
      this.showkeyboard = true;
    },
    onLicensePlateNumberInput(val) {
      this.orderInput.licensePlateNumber = val
        .toUpperCase()
        .replace(/\s*/g, "");
    },
    validDateChangCi() {
      let errorMsg = "";
      if (!this.hasCookieOrderInput) {
        if (!this.orderInput.groundId) {
          errorMsg += "请选择区域";
        } else if (!this.orderInput.changCiId) {
          errorMsg += "请选择参观时段";
        }
      }
      return errorMsg;
    },
    validChangCiSurplus(quantity) {
      let errorMsg = "";
      let changCi = this.changCis[0].children.find(
        (a) => a.value == this.orderInput.changCiId
      );
      if (changCi) {
        if (changCi.surplusNum < quantity) {
          errorMsg += "剩余数量不足。";
        }
      }
      return errorMsg;
    },
    validParkingAreaSurplus(quantity) {
      let errorMsg = "";

      if (this.busSpacingNum + this.carSpacingNum < quantity) {
        errorMsg += "停车位不足。";
      }

      return errorMsg;
    },
    onAdultQuantity(event) {
      let errorMsg = this.validDateChangCi();
      let minNum = 0;
      if (!errorMsg) {
        if (event > this.groupOrderMaxQuantity) {
          minNum = this.groupOrderMaxQuantity;
        } else {
          minNum = event;
        }
        errorMsg += this.validChangCiSurplus(minNum);
      }

      if (errorMsg) {
        this.$toast(errorMsg);
      } else {
        this.orderInput.adultQuantity = minNum;
        this.adultQuantity = minNum;
      }
    },
    onLicensePlateNumberQuantity(event) {
      let errorMsg = this.validDateChangCi();
      let minNum = 0;
      if (!errorMsg) {
        if (event > this.maximumParkingSpacesForTeamBooking) {
          minNum = this.maximumParkingSpacesForTeamBooking;
        } else {
          minNum = event;
        }
        errorMsg += this.validParkingAreaSurplus(minNum);
      }

      if (errorMsg) {
        this.$toast(errorMsg);
      } else if (minNum <= 0) {
        this.orderInput.needPackingLot = false;
      } else {
        this.licensePlateNumberQuantity = minNum;
      }
    },
    onValidate() {
      if (!this.validateInput()) {
        this.checked = false;
        return;
      }
      this.checked = !this.checked;
    },
    onContactCertNoFocus() {
      if (this.showContactNumberKeyboards) {
        document.activeElement.blur();
      }
    },
    onBlurContactNumberKeyboard() {
      try {
        let certRules = [
          {
            rule: "required",
          },
        ];
        certRules.push({
          rule: "isIdCard",
        });
        let result = validate([
          {
            value: this.contactCertNo.value,
            name: this.orderInput.contactName + "证件号码",
            rules: certRules,
          },
        ]);
        Vue.set(this.contactCertNo, "error", !result.success);
        Vue.set(this.contactCertNo, "errorMessage", result.message);
        if (!result.success) {
          this.$toast(result.message);
        }
      } finally {
        this.showContactNumberKeyboards = false;
      }
    },
    onShowContactNumberKeyboard() {
      document.activeElement.blur();
      this.showContactNumberKeyboards = true;
    },
    onBlurNumberKeyboard(index) {
      try {
        let certRules = [
          {
            rule: "required",
          },
        ];
        certRules.push({
          rule: "isIdCard",
        });
        let result = validate([
          {
            value: this.orderInput.adults[index].certNo.value,
            name: this.orderInput.adults[index].name.value + "证件号码",
            rules: certRules,
          },
        ]);
        Vue.set(this.orderInput.adults[index].certNo, "error", !result.success);
        Vue.set(
          this.orderInput.adults[index].certNo,
          "errorMessage",
          result.message
        );
        if (!result.success) {
          this.$toast(result.message);
        }
      } finally {
        this.showNumberKeyboards[index].show = false;
      }
    },
    onCertNoFocus(index) {
      if (this.showNumberKeyboards[index].show) {
        document.activeElement.blur();
      }
    },
    onShowNumberKeyboard(val) {
      document.activeElement.blur();
      for (var i = 0; i < this.showNumberKeyboards.length; i++) {
        this.showNumberKeyboards[i].show = false;
      }
      this.showNumberKeyboards[val].show = true;
    },
    onShowCarType(index) {
      this.showCarTypeIndex = index;
      this.showCarType = true;
    },
    onCarTypeSelecter(item) {
      if (item.num <= 0) {
        this.$toast("车位已满");
        return;
      }
      this.licensePlateNumbers[this.showCarTypeIndex].carTypeId = item.value;
      this.licensePlateNumbers[this.showCarTypeIndex].carTypeName = item.name;
      this.showCarType = false;
    },
    onSelectExplainerTimePoint(child, children) {
      children.map((a) => {
        a.selected = false;
      });
      child.selected = true;
    },
    onSelecterseert(item) {
      this.keYuanTypeId = item.value;
      this.keYuanTypeName = item.name;
      this.keydfseet = false;
    },
    dateChanged(index) {
      let date = this.options.dates[index];
      if (date.disable) {
        return;
      }
      this.orderInput.travelDate = date.date;
    },
    selectMoreDate() {
      this.showDateTimePicker = true;
    },
    confirmMoreDate(value) {
      this.showDateTimePicker = false;

      value = moment(value);
      this.orderInput.travelDate = value.format("YYYY-MM-DD");
      if (
        this.options.dates.filter((d) => d.date == this.orderInput.travelDate)
          .length <= 0
      ) {
        this.options.dates[this.options.dates.length - 1] = {
          date: this.orderInput.travelDate,
          text: value.format("ddd") + value.format("MM-DD"),
          disable: false,
        };
      }
    },
    setTravelDate() {
      this.orderInput.needPackingLot = false;
      this.orderInput.carTypeId = "";
      this.orderInput.licensePlateNumber = "";
      this.carTypes = [];

      if (this.orderInput.travelDate == "") {
        this.orderInput.travelDate = this.options.dates.filter(
          (d) => !d.disable
        )[0].date;
      } else {
        var temp = this.orderInput.travelDate;
        if (this.options.dates.filter((d) => d.date == temp).length > 0) {
          this.orderInput.travelDate = this.options.dates.filter(
            (d) => d.date == temp
          )[0].date;
        } else {
          var value = moment(temp);
          this.options.dates[this.options.dates.length - 1] = {
            date: temp,
            text: value.format("MM-DD") + value.format("ddd"),
            disable: false,
          };
          this.orderInput.travelDate =
            this.options.dates[this.options.dates.length - 1].date;
        }
      }
    },
    groundChange(event) {
      if (this.wxLastBookTime) return;
      this.orderInput.groundId = event.value;
      this.orderInput.needExplain = false;
      this.orderInput.needPackingLot = false;
      this.orderInput.carTypeId = "";
      this.orderInput.licensePlateNumber = "";
      this.carTypes = [];
    },
    changCiChange(event) {
      if (event.surplusNum <= 0) {
        this.$toast("该时段没有余票，请选择其它时段");
        return;
      }
      this.orderInput.changCiId = event.value;
      //停车场
      this.packingLotId = event.packingLotId;
      this.carSpacingNum = event.carSpacingNum;
      this.busSpacingNum = event.busSpacingNum;
      this.orderInput.needPackingLot = false;
      this.carTypeName = "";
      this.orderInput.carTypeId = "";
      this.orderInput.licensePlateNumber = "";
      this.carTypes = [];
      if (this.packingLotId) {
        if (this.carSpacingNum > 0) {
          this.carTypes.push({
            value: 1,
            name: "小型车",
            num: this.carSpacingNum,
          });
        }
        if (this.busSpacingNum > 0) {
          this.carTypes.push({
            value: 2,
            name: "大客车",
            num: this.busSpacingNum,
          });
        }
      }
    },
    async getChangCis(travelDate, groundId) {
      if (!travelDate || !groundId) {
        return;
      }

      if (dateHelper.validEqualDateNow(travelDate)) {
        this.wxLastBookTime = await scenicService.validExceedWxLastBookTime();
        if (this.wxLastBookTime) {
          return;
        }
      }

      this.orderInput.changCiId = "";
      //场次
      const changCis = await scenicService.getGroundChangCiItemsAsync({
        travelDate: travelDate,
        groundId: groundId,
      });
      this.changCis = [
        {
          text: "场次",
          children: changCis.map((c) => {
            return {
              value: c.changCiId,
              text: c.sTime + "-" + c.eTime,
              disabled: c.disabled,
              surplusNum:
                c.surplusNum > c.changCiNum ? c.changCiNum + "+" : c.surplusNum,
              packingLotId: c.packingLotId,
              carSpacingNum: c.carSpacingNum,
              busSpacingNum: c.busSpacingNum,
            };
          }),
        },
      ];
      if(this.changCis[0].children.length>0)
      {
        this.changCiChange(this.changCis[0].children[0]);
      }
      else{
        this.$toast("该区域未设置参观时段，请选择其它参观日期");
        return;
      }
      //讲解
      try {
        this.loadingExplainer = true;
        this.explainers = await explainerService.getSchedulingsAsync({
          Date: travelDate,
          TicketTypeId: groundId,
        });
      } finally {
        this.loadingExplainer = false;
      }
    },

    async getGrounds(travelDate) {
      if (!travelDate) {
        return;
      }
      this.wxLastBookTime = "";
      this.orderInput.groundId = "";
      var ticketTypeIds =
        this.ticketTypeIds == "0" ? [] : this.ticketTypeIds.split(",");

      var grounds = await scenicService.getGroundDtosAsync({
        travelDate: travelDate,
      });

      if (ticketTypeIds && ticketTypeIds.length > 0) {
        this.grounds = [];
        for (var i = 0; i < ticketTypeIds.length; i++) {
          for (var j = 0; j < grounds.length; j++) {
            if (
              grounds[j].value == ticketTypeIds[i] &&
              this.grounds.length == 0
            ) {
              this.grounds = [
                {
                  text: "区域",
                  children: [grounds[j]],
                },
              ];
            }

            if (grounds[j].value == ticketTypeIds[i] && !grounds[j].disabled) {
              this.grounds = [
                {
                  text: "区域",
                  children: [grounds[j]],
                },
              ];
              this.orderInput.groundId = ticketTypeIds[i];
              return;
            }
          }
        }
      } else {
        this.grounds = [
          {
            text: "区域",
            children: grounds,
          },
        ];
      }
    },
    setRegions(keYuanTypeId) {
      this.regions = this.areaItems.filter((a) => a.value == keYuanTypeId);
    },
    validateInput() {
      if (!this.orderInput.groundId) {
        this.$toast("请选择区域");
        return false;
      }

      if (!this.orderInput.changCiId) {
        this.$toast("请选择参观时段");
        return false;
      }
      if (!this.orderInput.customerName) {
       
          this.$toast("请输入团队名称。");
          return false;
      }
      if (
        !this.member.realNameFlag ||
        this.keYuanTypeId == 2 ||
        this.keYuanTypeId == 4
      ) {
        let selectedAgeRanges = this.ageRanges.filter((a) => a.personNum > 0);
        if (selectedAgeRanges.length <= 0) {
          this.$toast("请输入参观人数");
          return false;
        }
        this.orderInput.personNum = selectedAgeRanges
          .map((a) => a.personNum)
          .reduce((f, s) => s + f);

        if (this.orderInput.personNum > this.groupOrderMaxQuantity) {
          this.$toast(`每单最多${this.groupOrderMaxQuantity}人`);
          return false;
        }
        this.orderInput.ageRanges = selectedAgeRanges.map((a) => {
          return { ageRangeId: a.value, personNum: a.personNum };
        });
      } else {
        if (this.orderInput.adults.length <= 0) {
          this.$toast("请新增参观人数");
          return false;
        }

        for (let i = 0; i < this.orderInput.adults.length; i++) {
          let adult = this.orderInput.adults[i];
          let result = validate([
            {
              value: adult.name.value,
              name: "姓名",
              rules: [
                {
                  rule: "required",
                },
              ],
            },
          ]);
          Vue.set(adult.name, "error", !result.success);
          Vue.set(adult.name, "errorMessage", result.message);
          if (!result.success) {
            this.$refs.adultName[i].$refs.input.focus();
            this.$toast(result.message);
            return false;
          }

          let certRules = [
            {
              rule: "required",
            },
          ];
          if (adult.certTypeId == 5) {
            certRules.push({
              rule: "isIdCard",
            });
          }
          result = validate([
            {
              value: adult.certNo.value,
              name: adult.name.value + "证件号码",
              rules: certRules,
            },
          ]);
          Vue.set(adult.certNo, "error", !result.success);
          Vue.set(adult.certNo, "errorMessage", result.message);
          if (!result.success) {
            this.$toast(result.message);
            return false;
          }

          var adults = this.orderInput.adults.filter(function (elem) {
            return elem.certNo.value == adult.certNo.value;
          });
          if (adults.length > 1) {
            this.$toast(
              adults[0].name.value +
                "和" +
                adults[1].name.value +
                "的证件号码重复"
            );
            return false;
          }
        }

        let tourists = this.orderInput.adults.concat(this.orderInput.children);

        tourists = tourists.map((t) => {
          return {
            type: t.type,
            name: t.name.value,
            certTypeId: t.certTypeId,
            certNo: t.certNo.value,
            birthday: t.birthday,
          };
        });

        this.orderInput.tourists = tourists;
        this.orderInput.personNum = this.orderInput.adultQuantity;
      }
      // if (
      //   !this.member.realNameFlag ||
      //   this.keYuanTypeId == 2 ||
      //   this.keYuanTypeId == 4
      // ) {
      //   if (!this.member.registAreaId) {
      //     this.$toast("预约失败：单位注册所在地未填写，请联系工作人员处理。");
      //     return false;
      //   }
      // }
      // if (this.keYuanTypeId == 2 || this.keYuanTypeId == 4) {
      //   this.orderInput.keYuanTypeId = this.keYuanTypeId;
      //   this.orderInput.areaId = "";
      // } else {
      //   this.orderInput.areaId = this.member.registAreaId;
      //   this.orderInput.keYuanTypeId = 1;
      // }
      let validateRules = [
        {
          value: this.orderInput.contactName,
          name: "姓名",
          rules: [{ rule: "required" }],
        },
        {
          value: this.orderInput.contactMobile,
          name: "手机号",
          rules: [{ rule: "required" }, { rule: "isMobile" }],
        },
      ];
      let result = validate(validateRules);
      if (!result.success) {
        this.$toast(result.message);
        return false;
      }

      this.orderInput.certTypeId = 5;
      this.orderInput.certTypeName = "二代身份证";
      let certRules = [
        {
          rule: "required",
        },
      ];
      if (this.orderInput.certTypeId == 5) {
        certRules.push({
          rule: "isIdCard",
        });
      }
      result = validate([
        {
          value: this.contactCertNo.value,
          name: "联系人身份证号码",
          rules: certRules,
        },
      ]);
      Vue.set(this.contactCertNo, "error", !result.success);
      Vue.set(this.contactCertNo, "errorMessage", result.message);
      if (!result.success) {
        this.$toast(result.message);
        return false;
      }
      this.orderInput.contactCertNo = this.contactCertNo.value;

      if (this.orderInput.needPackingLot) {
        for (let i = 0; i < this.licensePlateNumbers.length; i++) {
          this.licensePlateNumbers[i].licensePlateNumber =
            this.licensePlateNumbers[i].licensePlateNumber
              .toUpperCase()
              .replace(/\s*/g, "");
          let result = validate([
            {
              value: this.licensePlateNumbers[i].carTypeId,
              name: "车辆类型" + (i + 1) + " ",
              rules: [{ rule: "required" }],
            },
          ]);
          if (!result.success) {
            this.$toast(result.message);
            return false;
          }
          result = validate([
            {
              value: this.licensePlateNumbers[i].licensePlateNumber,
              name: "车牌号码" + (i + 1) + " ",
              rules: [{ rule: "required" }, { rule: "isPlateNumber" }],
            },
          ]);
          if (!result.success) {
            this.$toast(result.message);
            return false;
          }
        }
        this.orderInput.plateNumbers = this.licensePlateNumbers;
      }
      
      if(this.orderInput.fileList.length<=0){
        this.$toast("请上传预约凭证");
        return false;
      }

      return true;
    },
    async onSubmit() {
      if (!this.validateInput()) {
        return;
      }

      this.orderInput.waiBinFlag =
        this.keYuanTypeId == 2 || this.keYuanTypeId == 4;
      this.orderInput.visitLetterPhotoArray = [];
      if (this.fileList.length > 0) {
        for (var i = 0; i < this.fileList.length; i++) {
          this.orderInput.visitLetterPhotoArray.push(this.fileList[i].content);
        }
      }

      this.orderInput.explainerTimeslotSchedulings = [];
      if (this.explainers.length > 0) {
        this.explainers.forEach((element) => {
          element.children.forEach((child) => {
            if (child.selected) {
              this.orderInput.explainerTimeslotSchedulings.push({
                groundID: element.value,
                timeslotId: child.value,
              });
            }
          });
        });
      }

      try {
        this.loading = true;
        let response = await orderService.createGroupOrderApplyAsync(
          this.orderInput
        );
        if (response.success) {
          Cookies.remove("orderInput");
          this.$router.replace({
            name: "orderinfo",
            params: {
              listNo: response.result,
              showNavbar: true,
            },
          });
        }
      } catch (err) {
        return;
      } finally {
        this.loading = false;
      }
    },
    onTempSave() {
      this.cookieOrderInput = this.orderInput;
      if (
        !this.member.realNameFlag ||
        this.keYuanTypeId == 2 ||
        this.keYuanTypeId == 4
      ) {
        let selectedAgeRanges = this.ageRanges.filter((a) => a.personNum > 0);
        if (selectedAgeRanges.length > 0) {
          this.cookieOrderInput.personNum = selectedAgeRanges
            .map((a) => a.personNum)
            .reduce((f, s) => s + f);
          this.cookieOrderInput.ageRanges = selectedAgeRanges.map((a) => {
            return { ageRangeId: a.value, personNum: a.personNum };
          });
        }
      } else {
        if (this.cookieOrderInput.adults.length > 0) {
          let tourists = this.cookieOrderInput.adults.concat(
            this.cookieOrderInput.children
          );
          tourists = tourists.map((t) => {
            return {
              type: t.type,
              name: t.name.value,
              certTypeId: t.certTypeId,
              certNo: t.certNo.value,
              birthday: t.birthday,
            };
          });
          this.cookieOrderInput.tourists = tourists;
          this.cookieOrderInput.personNum = this.cookieOrderInput.adultQuantity;
        }
      }

      if (this.keYuanTypeId == 2 || this.keYuanTypeId == 4) {
        this.cookieOrderInput.keYuanTypeId = this.keYuanTypeId;
        this.cookieOrderInput.areaId = "";
      } else {
        this.cookieOrderInput.areaId = this.member.registAreaId;
        this.cookieOrderInput.keYuanTypeId = 1;
      }

      this.cookieOrderInput.certTypeId = 5;
      this.cookieOrderInput.certTypeName = "二代身份证";
      this.cookieOrderInput.contactCertNo = this.contactCertNo.value;

      if (this.cookieOrderInput.needPackingLot) {
        this.cookieOrderInput.plateNumbers = this.licensePlateNumbers;
      }

      this.cookieOrderInput.explainerTimeslotSchedulings = [];
      if (this.explainers.length > 0) {
        this.explainers.forEach((element) => {
          element.children.forEach((child) => {
            if (child.selected) {
              this.cookieOrderInput.explainerTimeslotSchedulings.push({
                groundID: element.value,
                timeslotId: child.value,
              });
            }
          });
        });
      }
      
      Cookies.set("orderInput", this.cookieOrderInput, { expires: 1 });
      this.$toast("保存临时数据成功，有效期1天。");
    },
    initTime() {
      let now = moment();
      this.minHour = now.hour() > this.maxHour ? this.maxHour : now.hour();
    },
  },
  watch: {
    licensePlateNumberQuantity: function (newVal, oldVal) {
      try {
        let diff = newVal - oldVal;
        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            let licensePlateNumber = new LicensePlateNumber();
            this.licensePlateNumbers.push(licensePlateNumber);
          }
        } else {
          if (this.licensePlateNumbers.length + diff > 0) {
            this.licensePlateNumbers.length += diff;
          } else {
            this.licensePlateNumbers.length = 0;
          }
        }
      } finally {
        //finally
      }
    },
    "orderInput.adultQuantity": function (newVal, oldVal) {
      try {
        this.loading = true;
        let diff = newVal - oldVal;
        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            let adult = new Tourist();
            adult.type = "团体";
            this.orderInput.adults.push(adult);
            this.showNumberKeyboards.push({ show: false });
          }
        } else {
          if (this.orderInput.adults.length + diff > 0) {
            this.orderInput.adults.length += diff;
            this.showNumberKeyboards.length += diff;
          } else {
            this.orderInput.adults.length = 0;
            this.showNumberKeyboards.length = 0;
          }
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.travelDate": function (newVal, oldVal) {
      try {
        this.loading = true;
        this.orderInput.groundId = "";
        this.grounds = [];
        this.changCis = [];
        this.explainers = [];
        this.orderInput.needPackingLot = false;
        this.packingLotId = "";
        this.orderInput.carTypeId = "";
        this.orderInput.licensePlateNumber = "";
        this.carTypes = [];
        if (this.orderInput.travelDate == moment().format("YYYY-MM-DD")) {
          this.initTime();
        } else {
          this.minHour = defaultMinHour;
          this.orderInput.arrivalTime = defaultArrivalTime;
        }
        if (oldVal) {
          this.getGrounds(this.orderInput.travelDate).then(function () {});
          this.getChangCis(
            this.orderInput.travelDate,
            this.orderInput.groundId
          ).then(function () {});
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.groundId": function (newVal) {
      try {
        this.loading = true;
        this.orderInput.changCiId = "";
        this.changCis = [];
        this.explainers = [];
        if (newVal) {
          this.getChangCis(
            this.orderInput.travelDate,
            this.orderInput.groundId
          ).then(function () {});

          // if ((store.state.memberModule.member.customerId, this.orderInput.travelDate)) {
          //   orderService
          //     .getDailyOrderSurplusQuantityForCustomerAsync(
          //       store.state.memberModule.member.customerId,
          //       this.orderInput.travelDate,
          //       this.orderInput.groundId
          //     )
          //     .then((surplusQuantity) => {
          //       if (surplusQuantity <= 0) {
          //         this.$dialog.alert({
          //           message: `${this.orderInput.travelDate} 已达的团体订单场馆预约上限，请选择其它日期或场馆！`,
          //         });
          //       }
          //     });
          // }
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.needPackingLot": function (val) {
      try {
        this.loading = true;
        if (!val) {
          this.orderInput.carTypeId = "";
          this.carTypeName = "";
          this.orderInput.licensePlateNumber = "";
        } else {
          if (!this.orderInput.groundId) {
            this.orderInput.needPackingLot = false;
            this.orderInput.carTypeId = "";
            this.carTypeName = "";
            this.$toast("请选择区域");
            return;
          }
          if (!this.orderInput.changCiId) {
            this.orderInput.needPackingLot = false;
            this.orderInput.carTypeId = "";
            this.carTypeName = "";
            this.$toast("请选择参观时段");
            return;
          }
          if (!this.packingLotId) {
            this.orderInput.needPackingLot = false;
            this.orderInput.carTypeId = "";
            this.carTypeName = "";
            this.$toast("该区域没有停车场");
            return;
          }
          if (this.carTypes.length > 0) {
            var tempCarTypes = [];
            var num = 0;
            this.carTypes.forEach((item) => {
              if (item.num > 0) {
                tempCarTypes.push({
                  value: item.value,
                  name: item.name,
                  num: item.num,
                });
                num += item.num;
              }
            });
            this.carTypes = tempCarTypes;
            if (num <= 0) {
              this.orderInput.needPackingLot = false;
              this.orderInput.carTypeId = "";
              this.carTypeName = "";
              this.$toast("停车位不足");
              return;
            }
          } else {
            this.orderInput.needPackingLot = false;
            this.$toast("停车位不足");
            return;
          }
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.needExplain": async function (val) {
      try {
        this.loading = true;
        if (!val) {
          if (this.explainers.length > 0) {
            this.explainers.forEach((element) => {
              element.children.map((a) => {
                a.selected = false;
              });
            });
          }
        } else {
          if (!this.orderInput.groundId) {
            this.orderInput.needExplain = false;
            this.$toast("请选择区域");
            return;
          }
          if (!this.orderInput.changCiId) {
            this.orderInput.needExplain = false;
            this.$toast("请选择参观时段");
            return;
          }
          if (this.explainers.length == 0) {
            this.orderInput.needExplain = false;
            this.$toast("暂无讲解场次");
            return;
          }
          if (this.explainers.filter((d) => !d.disabled).length == 0) {
            this.orderInput.needExplain = false;
            this.$toast("暂无讲解场次");
            return;
          }
        }
      } finally {
        this.loading = false;
      }
    },
    regionId: function (val) {
      try {
        this.loading = true;
        this.orderInput.areaId = "";
        if (val == "") {
          this.areas = [
            {
              text: "",
              children: [],
            },
          ];
        } else {
          this.areas = this.regions[0].children.filter((r) => r.value == val);
        }
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    if (Cookies.get("orderInput")) {
      this.hasCookieOrderInput = true;
    }
    if (this.hasCookieOrderInput) {
      this.cookieOrderInput = JSON.parse(Cookies.get("orderInput"));
      //停车位数量
      this.licensePlateNumberQuantity =
        this.cookieOrderInput.plateNumbers.length;
      //参观人数
      this.orderInput.adultQuantity = this.cookieOrderInput.adultQuantity;
      this.adultQuantity = this.cookieOrderInput.adultQuantity;
    }
    this.options = await orderService.getOrderOptionsAsync(true, false);
    this.initTime();
    commonService.getAgeRangeComboboxItemsAsync().then((items) => {
      this.ageRanges = items.map((item) => {
        return {
          value: item.value,
          displayText: item.displayText,
          personNum: 0,
        };
      });
      //年龄段
      if (
        this.hasCookieOrderInput &&
        this.cookieOrderInput.ageRanges &&
        this.cookieOrderInput.ageRanges.length > 0
      ) {
        for (var i = 0; i < this.cookieOrderInput.ageRanges.length; i++) {
          this.ageRanges.forEach((item) => {
            if (item.value == this.cookieOrderInput.ageRanges[i].ageRangeId) {
              item.personNum = this.cookieOrderInput.ageRanges[i].personNum;
            }
          });
        }
      }
    });

    if (this.hasCookieOrderInput) {
      this.orderInput.travelDate = this.cookieOrderInput.travelDate;
    } else {
      this.setTravelDate();
    }

    // customerService.getCustomerComboboxItemsAsync().then((customerItems) => {
    //   this.restaurants = customerItems.map((c) => {
    //     return {
    //       value: c.displayText,
    //       id: c.value,
    //       registAreaTypeId: c.registAreaTypeId,
    //       registAreaId: c.registAreaId,
    //     };
    //   });
    // });


    var jobGetGrounds = await this.getGrounds(this.orderInput.travelDate);
    var jobGetChangCis = await this.getChangCis(
      this.orderInput.travelDate,
      this.orderInput.groundId
    );
    Promise.all([jobGetGrounds, jobGetChangCis])
      .then(() => {
        this.loading = true;
        if (
          this.hasCookieOrderInput &&
          this.orderInput.groundId == this.cookieOrderInput.groundId
        ) {
          //参观时段
          if (this.changCis && this.changCis[0].children) {
            this.changCis[0].children.forEach((changCi) => {
              if (changCi.value == this.cookieOrderInput.changCiId) {
                this.orderInput.changCiId = this.cookieOrderInput.changCiId;
                var event = changCi;
                if (event.surplusNum <= 0) {
                  this.$toast("该时段没有余票，请选择其它时段");
                  return;
                }

                //停车场
                this.packingLotId = event.packingLotId;
                this.carSpacingNum = event.carSpacingNum;
                this.busSpacingNum = event.busSpacingNum;
                this.orderInput.needPackingLot = false;
                this.carTypes = [];
                if (this.packingLotId) {
                  if (this.carSpacingNum > 0) {
                    this.carTypes.push({
                      value: 1,
                      name: "小型车",
                      num: this.carSpacingNum,
                    });
                  }
                  if (this.busSpacingNum > 0) {
                    this.carTypes.push({
                      value: 2,
                      name: "大客车",
                      num: this.busSpacingNum,
                    });
                  }
                }
                //停车位信息
                this.orderInput.needPackingLot =
                  this.cookieOrderInput.needPackingLot;
                this.licensePlateNumbers = this.cookieOrderInput.plateNumbers;
              }
            });
          }
          this.orderInput.arrivalTime = this.cookieOrderInput.arrivalTime;
          this.orderInput.contactName = this.cookieOrderInput.contactName;
          this.orderInput.contactMobile = this.cookieOrderInput.contactMobile;
          this.orderInput.jidiaoName = this.cookieOrderInput.jidiaoName;
          this.orderInput.memo = this.cookieOrderInput.memo;
          //参观人信息
          this.orderInput.adults = this.cookieOrderInput.adults;

          //讲解场次
          this.orderInput.needExplain = this.cookieOrderInput.needExplain;
          if (this.cookieOrderInput.explainerTimeslotSchedulings.length > 0) {
            for (
              var j = 0;
              j < this.cookieOrderInput.explainerTimeslotSchedulings.length;
              j++
            ) {
              this.explainers.forEach((element) => {
                if (
                  element.value ==
                    this.cookieOrderInput.explainerTimeslotSchedulings[j]
                      .groundID &&
                  element.children
                ) {
                  element.children.forEach((child) => {
                    if (
                      child.value ==
                      this.cookieOrderInput.explainerTimeslotSchedulings[j]
                        .timeslotId
                    ) {
                      child.selected = true;
                    }
                  });
                }
              });
            }
          }
          //客源类型
          this.keYuanTypeId = this.cookieOrderInput.keYuanTypeId.toString();
          //联系人身份证号
          this.contactCertNo.value = this.cookieOrderInput.contactCertNo;
        }
      })
      .catch(() => {})
      .finally(() => {
        this.hasCookieOrderInput = false;
        this.loading = false;
      });
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
.inline-input {
  /deep/ .el-input__inner {
    border: none;
    //width: calc(100vw - 120px);
  }
  ::-webkit-input-placeholder {
    /* Chrome */
    color: #969799;
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: #969799;
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: #969799;
    opacity: 1;
  }
  :-moz-placeholder {
    /* Firefox 4 - 18 */
    color: #969799;
    opacity: 1;
  }
}
</style>
<style lang="scss" >
.group-order {
  .van-hairline--top-bottom::after {
    border-width: 0;
  }

  .van-cell__value {
    text-align: left;
  }

  &-person {
    .van-cell {
      padding: 3px 15px;
    }

    .van-cell:not(:last-child)::after {
      border: none;
    }
  }

  &-tips {
    padding: 5px 10px;
    margin-top: 7px;
    margin-bottom: 10px;
    font-size: 12px;
    background-color: rgb(245, 249, 248);

    span {
      padding-left: 5px;
    }
  }

  &-switch {
    vertical-align: middle;
  }
}

.inline-cell {
  .van-cell {
    padding: 0;
  }

  .van-hairline--bottom::after {
    border-bottom-width: 0;
  }

  .van-cell:not(:last-child)::after {
    border-bottom-width: 0;
  }
}

.explain {
  display: flex;
  align-items: center;

  &-tips {
    margin-left: 10px;
    font-size: 12px;
    background-color: rgb(245, 249, 248);

    span {
      padding-left: 5px;
    }
  }
}
.pd {
  padding-left: 16px;
  padding-right: 16px;
}
.fz14 {
  font-size: 14px !important;
}
.van-cell {
  color: #646566;
}
.van-number-keyboard__title {
  font-size: 18px;
}
.van-key--blue {
  background-color: #845f56;
  color: #fff;
}
.adult-index {
  position: absolute;
  top: 14px;
  z-index: 100;
}
.van-field-red{
  .van-field__control{
    color: red;
  }
}
.van-field-notice{
  
}
.group-regist-preview{
  background-color: #810102;
    border-color: #810102;
    font-size: 10px;
    border-radius: 3px;
    color: #fff;
}
.uploader{
  .van-cell__value{
    display: flex;
    align-items: center;
  }
  .van-uploader__upload{
    margin: 0 8px 0 0 !important;
  }
  .van-uploader__upload-text{
    font-size: 10px;
  }
}
</style>